import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _310cdcd6 = () => interopDefault(import('../src/pages/account.vue' /* webpackChunkName: "pages/account" */))
const _5161eb02 = () => interopDefault(import('../src/pages/api.vue' /* webpackChunkName: "pages/api" */))
const _8d4d5a3a = () => interopDefault(import('../src/pages/billing.vue' /* webpackChunkName: "pages/billing" */))
const _af682c8c = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _27dbf020 = () => interopDefault(import('../src/pages/error.vue' /* webpackChunkName: "pages/error" */))
const _71f38cd1 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _656a3dad = () => interopDefault(import('../src/pages/orders.vue' /* webpackChunkName: "pages/orders" */))
const _1c09d107 = () => interopDefault(import('../src/pages/orders-old.vue' /* webpackChunkName: "pages/orders-old" */))
const _63810e6b = () => interopDefault(import('../src/pages/register.vue' /* webpackChunkName: "pages/register" */))
const _24947820 = () => interopDefault(import('../src/pages/users.vue' /* webpackChunkName: "pages/users" */))
const _85be2a22 = () => interopDefault(import('../src/pages/guide/api.vue' /* webpackChunkName: "pages/guide/api" */))
const _2c8c9450 = () => interopDefault(import('../src/pages/guide/billing.vue' /* webpackChunkName: "pages/guide/billing" */))
const _257acac0 = () => interopDefault(import('../src/pages/guide/orders.vue' /* webpackChunkName: "pages/guide/orders" */))
const _65b47c9d = () => interopDefault(import('../src/pages/guide/users.vue' /* webpackChunkName: "pages/guide/users" */))
const _1f329fc1 = () => interopDefault(import('../src/pages/order/_orderId/confirmation.vue' /* webpackChunkName: "pages/order/_orderId/confirmation" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _310cdcd6,
    name: "account___lt-LT"
  }, {
    path: "/api",
    component: _5161eb02,
    name: "api___lt-LT"
  }, {
    path: "/billing",
    component: _8d4d5a3a,
    name: "billing___lt-LT"
  }, {
    path: "/en-LT",
    component: _af682c8c,
    name: "index___en-LT"
  }, {
    path: "/error",
    component: _27dbf020,
    name: "error___lt-LT"
  }, {
    path: "/login",
    component: _71f38cd1,
    name: "login___lt-LT"
  }, {
    path: "/orders",
    component: _656a3dad,
    name: "orders___lt-LT"
  }, {
    path: "/orders-old",
    component: _1c09d107,
    name: "orders-old___lt-LT"
  }, {
    path: "/pl-PL",
    component: _af682c8c,
    name: "index___pl-PL"
  }, {
    path: "/register",
    component: _63810e6b,
    name: "register___lt-LT"
  }, {
    path: "/users",
    component: _24947820,
    name: "users___lt-LT"
  }, {
    path: "/en-LT/account",
    component: _310cdcd6,
    name: "account___en-LT"
  }, {
    path: "/en-LT/api",
    component: _5161eb02,
    name: "api___en-LT"
  }, {
    path: "/en-LT/billing",
    component: _8d4d5a3a,
    name: "billing___en-LT"
  }, {
    path: "/en-LT/error",
    component: _27dbf020,
    name: "error___en-LT"
  }, {
    path: "/en-LT/login",
    component: _71f38cd1,
    name: "login___en-LT"
  }, {
    path: "/en-LT/orders",
    component: _656a3dad,
    name: "orders___en-LT"
  }, {
    path: "/en-LT/orders-old",
    component: _1c09d107,
    name: "orders-old___en-LT"
  }, {
    path: "/en-LT/register",
    component: _63810e6b,
    name: "register___en-LT"
  }, {
    path: "/en-LT/users",
    component: _24947820,
    name: "users___en-LT"
  }, {
    path: "/guide/api",
    component: _85be2a22,
    name: "guide-api___lt-LT"
  }, {
    path: "/guide/billing",
    component: _2c8c9450,
    name: "guide-billing___lt-LT"
  }, {
    path: "/guide/orders",
    component: _257acac0,
    name: "guide-orders___lt-LT"
  }, {
    path: "/guide/users",
    component: _65b47c9d,
    name: "guide-users___lt-LT"
  }, {
    path: "/pl-PL/account",
    component: _310cdcd6,
    name: "account___pl-PL"
  }, {
    path: "/pl-PL/api",
    component: _5161eb02,
    name: "api___pl-PL"
  }, {
    path: "/pl-PL/billing",
    component: _8d4d5a3a,
    name: "billing___pl-PL"
  }, {
    path: "/pl-PL/error",
    component: _27dbf020,
    name: "error___pl-PL"
  }, {
    path: "/pl-PL/login",
    component: _71f38cd1,
    name: "login___pl-PL"
  }, {
    path: "/pl-PL/orders",
    component: _656a3dad,
    name: "orders___pl-PL"
  }, {
    path: "/pl-PL/orders-old",
    component: _1c09d107,
    name: "orders-old___pl-PL"
  }, {
    path: "/pl-PL/register",
    component: _63810e6b,
    name: "register___pl-PL"
  }, {
    path: "/pl-PL/users",
    component: _24947820,
    name: "users___pl-PL"
  }, {
    path: "/en-LT/guide/api",
    component: _85be2a22,
    name: "guide-api___en-LT"
  }, {
    path: "/en-LT/guide/billing",
    component: _2c8c9450,
    name: "guide-billing___en-LT"
  }, {
    path: "/en-LT/guide/orders",
    component: _257acac0,
    name: "guide-orders___en-LT"
  }, {
    path: "/en-LT/guide/users",
    component: _65b47c9d,
    name: "guide-users___en-LT"
  }, {
    path: "/pl-PL/guide/api",
    component: _85be2a22,
    name: "guide-api___pl-PL"
  }, {
    path: "/pl-PL/guide/billing",
    component: _2c8c9450,
    name: "guide-billing___pl-PL"
  }, {
    path: "/pl-PL/guide/orders",
    component: _257acac0,
    name: "guide-orders___pl-PL"
  }, {
    path: "/pl-PL/guide/users",
    component: _65b47c9d,
    name: "guide-users___pl-PL"
  }, {
    path: "/en-LT/order/:orderId?/confirmation",
    component: _1f329fc1,
    name: "order-orderId-confirmation___en-LT"
  }, {
    path: "/pl-PL/order/:orderId?/confirmation",
    component: _1f329fc1,
    name: "order-orderId-confirmation___pl-PL"
  }, {
    path: "/order/:orderId?/confirmation",
    component: _1f329fc1,
    name: "order-orderId-confirmation___lt-LT"
  }, {
    path: "/",
    component: _af682c8c,
    name: "index___lt-LT"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
